import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NgTemplateOutlet } from '@angular/common';
import { AddStepListComponent } from '../../components/add-step-list/add-step-list.component';
import { DynamicActionPanelLoaderComponent } from '../../component-loader/dynamic-action-panel-loader/dynamic-action-panel-loader.component';
import { DynamicTriggerPanelLoaderComponent } from '../../component-loader/dynamic-trigger-panel-loader/dynamic-trigger-panel-loader.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { AutomationsSideDrawerService } from '../automations-side-drawer-service';

@Component({
  selector: 'automata-automations-side-menu-drawer',
  templateUrl: './automations-side-menu-drawer.component.html',
  styleUrls: ['./automations-side-menu-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDrawer,
    NgTemplateOutlet,
    AddStepListComponent,
    DynamicActionPanelLoaderComponent,
    DynamicTriggerPanelLoaderComponent,
  ],
})
export class AutomationsSideMenuDrawerComponent implements OnInit {
  @ViewChildren('sideMenuDrawer') sideMenuDrawer: QueryList<MatDrawer>;

  dontOpen = input(false);

  constructor(
    public readonly sideMenuService: AutomationsSideDrawerService,
    private readonly destroyRef: DestroyRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.sideMenuService.open$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((open) => {
          if (open) {
            this.sideMenuDrawer?.first.open('program');
          } else if (this.sideMenuDrawer) {
            this.sideMenuDrawer.first.close();
            this.sideMenuService.currentSideMenuType = '';
          }
        }),
      )
      .subscribe();

    this.sideMenuService.detectChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.cdr.detectChanges();
    });
  }
}
